import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

export function initHomeMainSwiper() {
  if (!document.querySelector('.js-swiper-home-main')) {
    return
  }

  const homeMainSwiper = new Swiper('.js-swiper-home-main', {
    autoplay: {
      delay: 3000,
    },
    loop: true,
    pagination: {
      el: '.js-swiper-home-main-pagination',
      type: 'progressbar'
    }
  })

  document.querySelector('.js-swiper-home-main-learn-more').addEventListener('click', () => {

    homeMainSwiper.el
      .querySelector('.swiper-slide-active')
      .querySelector('a')
      .click()
  })
}
